import React, { createContext, ReactNode, useContext } from 'react';

export interface ExperimentCohorts {
  cohort: string | null;
  experiment_name: string;
  name?: string;
  forced?: boolean;
  mocked?: {
    status: boolean;
  };
}

export interface ExperimentContextValue {
  getExperiment: (name: string) => ExperimentCohorts | null;
}

export const ExperimentContext = createContext<ExperimentContextValue | null>(
  null
);

if (process.env.NODE_ENV === 'development') {
  ExperimentContext.displayName = 'ExperimentContext';
}

export const useStravaExperiment = () => {
  const context = useContext(ExperimentContext);

  if (!context) {
    throw new Error(
      'useStravaExperiment must be used within the ExperimentProvider'
    );
  }

  return context;
};

export interface ExperimentProviderProps
  extends Partial<ExperimentContextValue> {
  children: ReactNode;
}

export const ExperimentProvider = ({
  children,
  ...experimentContextValue
}: ExperimentProviderProps) => {
  return (
    <ExperimentContext.Provider
      value={{
        getExperiment: (_: string) => null,
        ...experimentContextValue
      }}
    >
      {children}
    </ExperimentContext.Provider>
  );
};

if (process.env.NODE_ENV === 'development') {
  ExperimentProvider.displayName = 'ExperimentProvider';
}
